import React from 'react';
import { Text } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';

const items = [
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_1.png'),
    //   width: 1250,
    //   height: 1679,
    // },
    title: "Let’s Start a Project",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>You have two (2) choices if you already have a contractor and a quote and two (2) choices if you don't.</Text>,
    ],
    sections: [
      {
        title: "If You Have A Contractor And A Quote:",
        description: "Your decision of who creates the project will be based on whether you feel comfortable creating the scope of work, milestones and the amount of payment for each milestone. Either party has a chance to recommend changes to the project and payments the other has suggested.",
        items: [
          {
            name: "Create A Project And Invite Your Contractor",
            text: null,
            // note: "When you create the Project the default Renovation Trust fee structure is a 50/50 split between you and your contractor. If you have agreed to any other arrangement with your contractor where they are either paying all or none of the Renovation Trust fees, your contractor MUST create the Project.",
            note: null,
          },
          {
            name: "Ask Your Contractor To Invite You",
            text: null,
            note: null,
          }
        ],
        footer: [
          // "Your decision about who creates the Project will be based on if you feel comfortable creating the scope of work and creating the milestones and the amount of payment at each milestone. Either party has a chance to recommend changes to the terms and payments the other party has suggested. As well if the Renovation Trust fees are anything other than the 50/50 default split, the contractor must create the project.",
          // <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Your decision about who creates the Project will be based on if you feel comfortable creating the scope of work and creating the milestones and the amount of payment at each milestone. Either party has a chance to recommend changes to the terms and payments the other party has suggested. As well if the Renovation Trust fees are anything other than the 50/50 default split, the contractor must create the project.</Text>,
        ],
      },
      {
        title: "If You DO NOT Have A Contractor Or A Quote: ",
        items: [
          {
            name: "Create Your Project For Later",
            text: "You can continue to work on it until you are ready to send it to contractors for quotes or, if you've selected a contractor, invite them to join the project.",
            note: null,
          },
          {
            name: "Get Quotes",
            text: "You can create your project and send it to contractors to provide you with a quote. This allows you to give a detailed description with diagrams and photos to make sure contractors are quoting apples to apples. You will need contractors’ emails or cell phone numbers in order to invite them to quote.",
            note: null,
          }
        ],
        footer: [
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.lightText, CS.boldText]}>REMEMBER</Text> - We DON'T recommend or refer contractors. We're a neutral 3rd party protecting your money during any type of renovation, construction, or home improvement project.</Text>,
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.lightText, CS.boldText]}>NEVER GIVE A DEPOSIT </Text> - This is how we protect you. Your contractor gets paid at your agreed to milestones - as your project progresses and/or on completion.</Text>,
        ],
      }
    ],
    mustHave: null,
    need: null,
  },
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_2.png'),
    //   width: 1250,
    //   height: 1679,
    // },
    title: "Create A Project And Invite My Contractor",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If you have your contractor's email address or cell phone number, a quote you agree with and know the milestones you will pay your contractor at, then you are ready to create your project.</Text>,
    ],
    sections: [],
    // mustHave: {
    //   items: [
    //     "Contractor whom you want to do the work",
    //     "A quote or contract",
    //   ],
    //   description: [
    //     "If you have your contractors email address or cell phone number and have a quote you agree with and you know when you will pay your contractor (Milestones) but not give a deposit, you are good to Create your Project.",
    //     "If you are creating the Project, the Renovation Trust fee structure is 50/50. It can NOT be changed later. If you have agreed to any other arrangement with your contractor where they are either paying all or none of the Renovation Trust fees, your contractor MUST create the Project.",
    //   ]
    // },
    mustHave: null,
    need: {
      items: [
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Project Name</Text> - example: My Kitchen Renovation</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Location of Project</Text> - address where the project will take place</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Name</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Business Name</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractors Email and/or Cell Phone Number</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Quote or Contract</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Scope of Work</Text> - the more detail the better</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Milestones and Payments</Text> - when you want to release funds - based on work completed or material on-site</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Drawings, Blueprints and Photos</Text></Text>,
      ],
      description: [
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.boldText, CS.lightText]}>REMINDER</Text> - Milestone payments should be roughly 90% of the value of the work completed or materials on-site up until the final payment.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.boldText, CS.lightText]}>FEE STRUCTURE</Text> - Unless your contractor is a Renovation Trust Trusted Contractor, you are agreeing to a 50/50 fee split of the Renovation Trust protection fees. This cannot be changed later.</Text>,
      ]
    },
    source: 'https://renovationtrust.s3.ca-central-1.amazonaws.com/production/resources/creatingAProject.mp4',
    youtube: 'wdiwWQSCtzo',
    button: 'Create a project and invite my contractor',
    goTo: '/project/new',
  },
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_3.png'),
    //   width: 1250,
    //   height: 1679,
    // },
    title: "Ask My Contractor To Invite Me",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If you are uncomfortable with adding the scope of work, milestones or the amount of payment for each milestone, asking your contractor to create the project and invite you is a great alternative.</Text>,
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Speak to your contractor directly and ask them to create your project and invite you. While we will reach out on your behalf, by email and text/SMS, your forewarning can avoid messages being ignored or lost in spam folders. Let your contractor know that Renovation Trust protects both of you. And that once you both agree to the project terms, you will fund the entire cost of the project where Renovation Trust will hold the money and release it to them at your agreed to milestones.</Text>,
      // <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.boldText, CS.lightText]}>REMINDER</Text> – Milestone payments should be roughly 90% of the value of the work completed or materials on-site up until the final payment. Never pay a deposit or prepayment.</Text>,
    ],
    sections: [],
    // mustHave: {
    //   items: [
    //     "Contractor whom you want to do the work",
    //     "A quote or contract",
    //   ],
    //   description: [
    //     "Speak to your contractor you have chosen directly and ask them to CREATE your Project in Renovation Trust.  You can then accept the Project as described or suggest changes. You should have already received a quote and you know the price. ",
    //     "If they are new to Renovation Trust they will need to create an account.",
    //     "By clicking Below on “Have Contractor Create My Project” an email will be sent with a message asking them to Create Your Project and Invite You.",
    //     "Please call to follow up with your contractor confirming they received the invite, and they are proceeding in creating the Project and inviting you.",
    //     "You should let the contractor know that Renovation Trust protects you and them, that once you both agree to the Project terms, you will fund the entire cost of the Project, Renovation Trust will hold the money and pay them at agreed to milestones as work is completed. There should be no deposit or prepayment.",
    //     "Reminder – Milestone payments should be roughly 90% of the value of the work completed or materials on site up until the final payment. Do not pay a deposit or any prepayment.",
    //   ]
    // },
    mustHave: null,
    need: {
      items: [
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Project Name</Text> - example: My Kitchen Renovation</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Location of Project</Text> - address where the project will take place</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Name</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Business Name</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Email and/or Cell Phone Number</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Quote or Contract</Text></Text>,
      ],
      description: [
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>From this, your contractor will create the project and invite you to join it.</Text>,
      ]
    },
    source: null,
    youtube: null,
    button: 'Ask My Contractor To Create My Project',
    goTo: '/contractor/0/invite?inviteType=Create&role=homeowner',
  },
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_4.png'),
    //   width: 1220,
    //   height: 1446,
    // },
    title: "Create My Project For Later",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If you just have an idea, or aren't ready to share it with a contractor, you can create a project and save it for later. Add inspirational photos of what you want your project to look like. Include materials you may want to use.</Text>,
    ],
    sections: [],
    // mustHave: {
    //   items: [
    //     "An Idea or dream",
    //   ],
    //   description: [
    //     "You can create your Project and save it for a later date, either to keep adding to it, to invite Contractors to quote or to invite a contractor to begin work.",
    //     "You can add Inspirational Photos of what you want your Project to look like, materials you may want to use etc.",
    //   ]
    // },
    mustHave: null,
    need: {
      items: [
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Project Name</Text> - example: My Kitchen Renovation</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Location of Project</Text> - address where the project will take place</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Inspirational Photos</Text></Text>,
      ],
      description: [
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Take as much time as you like. When you're ready, invite contractors to quote on your project.</Text>,
      ]
    },
    source: 'https://renovationtrust.s3.ca-central-1.amazonaws.com/production/resources/creatingAProject.mp4',
    youtube: 'wdiwWQSCtzo',
    button: 'Create my project',
    goTo: '/project/new',
  },
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_4.png'),
    //   width: 1220,
    //   height: 1446,
    // },
    title: "Get Quotes",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>You will need the names, emails and/or cell phone numbers of contractors in order to invite them to quote on your project. We do not refer contractors.</Text>,
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Be as detailed as possible in your scope of work to give a complete picture of what you expect. Include very detailed descriptions, diagrams, and photos to make sure contractors are quoting <Text style={[CS.italicText]}>apples to apples</Text>.</Text>,
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Any diagrams or pictures in <Text style={[CS.italicText]}>Project Documents</Text> will become part of the legal contract both the contractor and you must follow.</Text>,
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>You can add inspirational photos of how you want your project to look or materials you'd like used; this is your wish list. This gives contractors an idea of what you are looking for - they are not legally binding.</Text>,
    ],
    sections: [],
    // mustHave: {
    //   items: [
    //     "An Idea or dream",
    //     "Contractor(s) whom you want a quote from",
    //   ],
    //   description: [
    //     "You will create your Project and invite contractors to quote your Project.",
    //     "You will have to have contractors’ names, emails or cell phone numbers to be able to send them the invitation to quote. We do not provide or recommend contractors.",
    //     "You should be as detailed as possible in your scope of work to give a complete picture of your Project. Include very detailed descriptions, diagrams, and photos to make sure contractors are quoting on apples to apples. Any diagrams or pictures in Project Documents will become part of the “legal” documents both the contractor and you must follow. Inspirational photos are just “ideas” and not part of the Project documentation until you add it.",
    //     "You can add Inspirational Photos of what you want your Project to look like, materials you may want to use etc. This is your wish list. This gives contractors an idea what you are looking for.",
    //   ]
    // },
    mustHave: null,
    need: {
      items: [
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Project Name</Text> - example: My Kitchen Renovation</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Location of Project</Text> - address where the project will take place</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Scope of work</Text> - the more detail the better</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Drawings, Blueprints and Photos</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Inspirational Photos</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Name</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Business Name</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Contractor's Email and/or Cell Phone Number</Text></Text>,
      ],
      description: [
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Take as much time as you need. When you are ready, invite contractors to quote on your project.</Text>,
      ],
    },
    source: 'https://renovationtrust.s3.ca-central-1.amazonaws.com/production/resources/creatingAProject.mp4',
    youtube: 'wdiwWQSCtzo',
    button: 'Create my project',
    goTo: '/project/new',
  },
];

export default items;